// 语言代码参考 http://www.lingoes.net/zh/translator/langcode.htm
import Vue from 'vue';
import Vuei18n from 'vue-i18n';
import { Lang } from '@/store/types';
import zhCh from '@/i18n/lang/zhCN';
import enUS from '@/i18n/lang/enUS';

Vue.use(Vuei18n);

const i18n = new Vuei18n({
    locale: Lang.zhCN, // 设置地区
    messages: {
        [Lang.zhCN]: zhCh,
        [Lang.enUS]: enUS,
    },
});

export default i18n;
